import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import ProductInput from '../../commons/Inputs/productInfoInput';
import styles from '../../style/productdetail';

const WeightWithUnit = ({
  onChangeText,
  onChangeUnit,
  onSubmitEditing,
  editable,
  value,
  weightFormat,
  label,
  right,
  style
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const weightUnitOptions = [
    { label: 'oz', value: 'oz' },
    { label: 'lb', value: 'lb' },
    { label: 'g', value: 'g' },
    { label: 'kg', value: 'kg' }
  ];

  let marginLeft = 14;
  let testID = 'categoryInput';


  const handleUnitSelect = (unit) => {
    onChangeUnit(unit);
    setDropdownOpen(false);
  };

  const displayValue = value != null ? String(value) : '';

  return (
    <View style={[styles.viewGap, {marginLeft: right ? marginLeft : ''}, style]}>
      <Text style={[styles.productInfoText]}>
        {label}
      </Text>
      <View style={localStyles.inputContainer}>
        <ProductInput
          style={[styles.productInfoInput, localStyles.weightInput]}
          onChangeText={(text) => { onChangeText(text) }}
          onSubmitEditing={() => { onSubmitEditing && onSubmitEditing() }}
          editable={editable}
          value={displayValue}
          id={testID}
        />

        <View style={localStyles.unitDropdownContainer}>
            <select
              style={localStyles.webSelect}
              value={weightFormat || 'oz'}
              onChange={(event) => handleUnitSelect(event.target.value)}
            >
              {weightUnitOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                  style={localStyles.webOption}
                >
                  {option.label}
                </option>
              ))}
            </select>
        </View>
      </View>
    </View>
  );
};

const localStyles = StyleSheet.create({
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    width: '100%'
  },
  weightInput: {
    width: '75%',
    marginRight: 5
  },
  unitDropdownContainer: {
    width: '23%',
    position: 'relative',
    zIndex: 10
  },
  webSelect: {
    cursor: 'pointer',
    width: '100%',
    height: 35,
    backgroundColor: 'transparent',
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0.5,
    borderBottomColor: '#fff',
    color: '#fff',
    fontSize: 14,
    fontFamily: 'inherit',
    outline: 'none'
  },
  webOption: {
    backgroundColor: '#333',
    color: '#fff',
    padding: 5
  },
  dropdownItem: {
    padding: 10,
    borderBottomWidth: 0.5,
    borderBottomColor: '#ccc'
  }
});

export default WeightWithUnit;
